import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';

import {
    Paper,
    Divider,
    styled,
    Grid,
    Box,
    Button,
    Modal,
    Typography,
    Card,
    CardHeader,
    CardContent
} from "@mui/material";
import {
  Collapse, IconButton, 
} from '@mui/material';
import Autocomplete from "@mui/material/Autocomplete";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { fetchAddressBookDetails } from './addressbookSlice';
import { fetchCountry, fetchState, fetchMultiStates } from '../../../pages/General/countryStateCitySlice';
import { fetchSenderAddress } from '../../../pages/Settings/AddressSender/addressSenderSlice';

const SenderAddressSelect = ({ values,errors, addresssender, isReturnOrder, senderAddressObjectId, dispatchSenderAddressCallback, dispatchSenderCountryCallback, dispatchInputChangeCallback,setValues }) => {
    const dispatch = useDispatch();
    const country_code = useSelector(state => state.countrystate.country);
    const state = useSelector(state => state.countrystate.multistates);
    const addressbooksearchvalues = useSelector((state) => state.addressbook && state.addressbook.getsearchvalues);
    const [addressSearchBy, setAddressSearchBy] = useState("name");
    const [addressSearchByValue, setAddressSearchByValue] = useState("");
    const filteredCountryData = country_code.data.filter(({ code }) => code );
    const onChangeCountry = id => {
        dispatchSenderCountryCallback(id)
    }
    const onsenderaddresschange = (id) => {
        dispatchSenderAddressCallback(id)
    }
    
    const handleInputChange = e => {
        const { name, value } = e.target
        dispatchInputChangeCallback(name, value)
    }

    useEffect(() => {
        dispatch(fetchSenderAddress());
    }, [dispatch]);

    useEffect(() => {
        if (values.sender_country_code && values.sender_country_code!='') {
            dispatch(fetchMultiStates(values.sender_country_code));
        }
    }, [values.sender_country_code]);

    
      const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
          if (key.code == country_code) {
            filteredValue = key;
          }
        });
         return filteredValue;
      };

      const onSelectStateChange = (currentstate) => {
        dispatchInputChangeCallback("sender_province_code", currentstate)
      };
    
      const getSelectedState = (currentstate) => {
        let filteredStateValue = { code: "", name: "" };
        let tempState = "";
        state &&
          state.data &&
          state.data.map((key) => {
            if (key.code == currentstate && tempState == "") {
              filteredStateValue = key;
              tempState = "success";
            }
          });
        return filteredStateValue;
      };

       useEffect(() => {
              if(isReturnOrder==undefined || isReturnOrder==false){
                  dispatch(fetchAddressBookDetails(addressSearchBy, ""))
              }
          }, [addressSearchBy])
      
          useEffect(() => {
              if(isReturnOrder==undefined || isReturnOrder==false){
                  dispatch(fetchAddressBookDetails(addressSearchBy, addressSearchByValue))
              }
          }, [addressSearchByValue])
      
          const [labelgetvalues, setlabelgetvalues] = useState([]);
      
      
          const onSearchLabelChange = (event, value) => {
              if (value != null && value != "") {
                  setValues({
                      ...values,
                      sender_name: value.name ? value.name : "",
                      sender_company: value.company ? value.company : "",
                      sender_phone: value.phone ? value.phone : "",
                      sender_email: value.email ? value.email : "",
                      sender_address: value.address ? value.address : "",
                      sender_address2: value.address2 ? value.address2 : "",
                      sender_city: value.city ? value.city : "",
                      sender_postal_code: value.postal_code ? value.postal_code : "",
                      sender_country_code: value.country_code ? value.country_code.toUpperCase() : "",
                      sender_province_code: value.province_code ? value.province_code.toUpperCase() : ""
                  });
                  dispatch(fetchState(value.country_code));
                  
              }
          }
      
          useEffect(() => {
              if (addressbooksearchvalues && addressbooksearchvalues.data) {
                  let searchvaluearray = []
                  Object.entries(addressbooksearchvalues.data).map((entry) => {
                      entry.map((item) => {
                          if (typeof item == "object") {
                              searchvaluearray.push(item)
                          }
                      });
                  });
                  setlabelgetvalues(searchvaluearray)
              }
          }, [addressbooksearchvalues.data]);
            const [isExpanded, setIsExpanded] = useState(false);

            const handleToggleExpand = () => {
                setIsExpanded(!isExpanded);
            };

    return (
        <>
          {/* RIGHT PART MODULE: Sender Address Directory Configuration Surface panel */}
            <Card
                sx={{ 
                    width: '100%',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%' // Mandates structural equal height matching with the sibling Line Item component
                }}
                className="sc--cardhead--details"
            >
                <CardHeader 
                    title={
                        <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                            Sender
                        </Typography>
                    } 
                    action={
                        <IconButton 
                            onClick={handleToggleExpand}
                            sx={{ color: '#64748B', '&:hover': { backgroundColor: '#F1F5F9' } }}
                        >
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    }
                    onClick={handleToggleExpand}
                    style={{ cursor: 'pointer' }}
                    sx={{ p: 2.5, backgroundColor: '#FFFFFF', flexShrink: 0 }}
                />
                <Divider sx={{ borderColor: '#E2E8F0' }} />
                
                {/* Dynamic scroll context container for expanded content configurations */}
                <Box sx={{ flexGrow: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
                    
                    

                    {/* Collapsed Dynamic Sender Address Text Box View Panel Standard */}
                    {!isExpanded && (
                        <CardContent sx={{ p: 2.5, pt: 0, pb: 2.5 }}>
                            <Box 
                                onClick={handleToggleExpand}
                                sx={{ 
                                    p: 2, 
                                    backgroundColor: '#F8FAFC', 
                                    border: '1px solid #E2E8F0', 
                                    borderRadius: '10px',
                                    cursor: 'pointer',
                                    transition: 'all 0.15s ease-in-out',
                                    '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1' }
                                }}
                            >
                                {values.sender_name || values.sender_address || values.sender_city ? (
                                    <Typography variant="body2" noWrap sx={{ color: '#334155', fontWeight: 600, width: '100%' }}>
                                        {values.sender_name && <span>{values.sender_name}</span>}
                                        {values.sender_company && <span style={{ color: '#64748B', fontWeight: 500 }}>{` (${values.sender_company})`}</span>}
                                        {(values.sender_address || values.sender_city) && <Box component="span" sx={{ color: '#94A3B8', mx: 1 }}>•</Box>}
                                        <Box component="span" sx={{ color: '#475569', fontWeight: 400 }}>
                                            {[values.sender_address, values.sender_address2, values.sender_city, values.sender_province_code, values.sender_postal_code, values.sender_country_code].filter(Boolean).join(', ')}
                                        </Box>
                                        {values.sender_phone && (
                                            <>
                                                <Box component="span" sx={{ color: '#94A3B8', mx: 1 }}>•</Box>
                                                <span style={{ color: '#64748B', fontWeight: 400 }}>{values.sender_phone}</span>
                                            </>
                                        )}
                                    </Typography>
                                ) : (
                                    <Typography variant="body2" sx={{ color: '#94A3B8', fontWeight: 500, fontStyle: 'italic' }}>
                                        None available. Expand to populate information.
                                    </Typography>
                                )}
                            </Box>
                        </CardContent>
                    )}
                    
                    {/* Progressive Disclosure Collapse Wrapper Area: Safely encapsulates all deep input configurations until expansion click triggers */}
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit sx={{ flexGrow: 1 }}>
                        <CardContent sx={{ p: 2.5, pt: 1 }}>
                            <div> {/* Protective boundary node preventing stack style interferences */}
                                {/* Primary Address Picker Area - Stays visible initially on a clean single line */}
                                {isReturnOrder ?
                                    <CardContent sx={{ p: 2.5, pb: isExpanded ? 1.5 : 0, flexShrink: 0 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4}>
                                                <FormControl fullWidth variant="outlined" size="small" error={!!errors.dimension_unit}>
                                                    <InputLabel id="search-by-select-outlined-label">Search by</InputLabel>
                                                    <Select
                                                        labelId="search-by-select-outlined-label"
                                                        id="search-by-select-outlined"
                                                        name="search_by"
                                                        onChange={(event) => { setAddressSearchBy(event.target.value) }}
                                                        value={addressSearchBy}
                                                        label="Search by"
                                                        sx={{ 
                                                            borderRadius: '10px',
                                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' }
                                                        }}
                                                    >
                                                        <MenuItem value="name">Name</MenuItem>
                                                        <MenuItem value="company">Company</MenuItem>
                                                        <MenuItem value="address">Address</MenuItem>
                                                        <MenuItem value="address2">Addres2</MenuItem>
                                                        <MenuItem value="city">City</MenuItem>
                                                        <MenuItem value="province_code">Province code</MenuItem>
                                                        <MenuItem value="country_code">Country code</MenuItem>
                                                        <MenuItem value="postal_code">Postal code</MenuItem>
                                                        <MenuItem value="email">Email</MenuItem>
                                                        <MenuItem value="phone">Phone</MenuItem>
                                                        <MenuItem value="customer_id">Customer id</MenuItem>
                                                        <MenuItem value="reference">Reference</MenuItem>
                                                        <MenuItem value="reference2">Reference2</MenuItem>
                                                        <MenuItem value="reference3">Reference3</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            
                                            <Grid item xs={12} sm={8}>
                                                <Autocomplete
                                                    disablePortal
                                                    size="small"
                                                    name="search_value"
                                                    id="combo-box-demo"
                                                    noOptionsText={"No matches found"}
                                                    loading={addressbooksearchvalues && addressbooksearchvalues.loading}
                                                    options={labelgetvalues || []}
                                                    filterOptions={(options) => options}
                                                    sx={{
                                                        width: '100%',
                                                        '& .MuiOutlinedInput-root': { 
                                                            borderRadius: '10px',
                                                            '& fieldset': { borderColor: '#E2E8F0' }
                                                        }
                                                    }}
                                                    renderOption={(props, option) => (
                                                        <MenuItem {...props} value={option._id} key={option._id} sx={{ py: 1.25, borderBottom: '1px solid #F1F5F9' }}>
                                                            {/* Single-line text wrap preventing two-line cluttering layouts */}
                                                            <Typography variant="body2" noWrap sx={{ color: '#1E293B', fontWeight: 500, width: '100%' }}>
                                                                <strong>{option.name}</strong> {option.company ? `(${option.company})` : ''} 
                                                                <Box component="span" sx={{ color: '#94A3B8', mx: 1 }}>•</Box>
                                                                <Box component="span" sx={{ color: '#64748B', fontWeight: 400 }}>
                                                                    {option.address}, {option.city}, {option.province_code}, {option.country_code} - {option.postal_code}
                                                                </Box>
                                                            </Typography>
                                                        </MenuItem>
                                                    )}
                                                    onInputChange={(event, value, reason) => {
                                                            if ( ! value.includes(",") && reason != "reset") {
                                                                setAddressSearchByValue(value)
                                                            }
                                                        }
                                                    }
                                                    onChange={(event, value) => onSearchLabelChange(event, value)}
                                                    getOptionLabel={(option) => ( ""+option.name+" ("+option.company+")"+", "+ option.address ) }
                                                    renderInput={(params) => (
                                                        <TextField 
                                                            {...params} 
                                                            label="Search Sender Directory..." 
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    :
                                    <CardContent sx={{ p: 2.5, pb: isExpanded ? 1.5 : 0, flexShrink: 0 }}>
                                        <Box className="sc--form--center" sx={{ width: '100%' }}>
                                            <FormControl fullWidth variant="outlined" size="small" error={!!errors.preferred_sender_id}>
                                                <InputLabel id="sender-address-select-label">Sender Address</InputLabel>
                                                <Select
                                                    labelId="sender-address-select-label"
                                                    id="sender-address-select"
                                                    name="preferred_sender_id"
                                                    value={senderAddressObjectId}
                                                    onChange={e => {
                                                        onsenderaddresschange(e.target.value,false)
                                                    }}
                                                    label="Sender Address"
                                                    sx={{ 
                                                        borderRadius: '10px',
                                                        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' }
                                                    }}
                                                >
                                                    {addresssender && addresssender.data && addresssender.data.map((item) => {
                                                        return (
                                                            <MenuItem value={item._id} key={item._id} sx={{ py: 1.25, borderBottom: '1px solid #F1F5F9' }}>
                                                                {/* Cleaned layout output ensuring full context preview aligns onto a single row */}
                                                                <Typography variant="body2" noWrap sx={{ color: '#1E293B', fontWeight: 500, width: '100%' }}>
                                                                    <strong>{item.sender_name}</strong> {item.sender_company ? `(${item.sender_company})` : ''}
                                                                    <Box component="span" sx={{ color: '#94A3B8', mx: 1 }}>•</Box>
                                                                    <Box component="span" sx={{ color: '#64748B', fontWeight: 400 }}>
                                                                        {item.sender_address}, {item.sender_city}, {item.sender_state_code}, {item.sender_country_code} - {item.sender_postal_code}
                                                                    </Box>
                                                                </Typography>
                                                            </MenuItem>
                                                        )
                                                    })}
                                                </Select>

                                                <FormHelperText sx={{ mx: 0.5, mt: 0.75, fontWeight: 500 }}>
                                                    {(addresssender && addresssender.loading === false)
                                                        && addresssender && addresssender.data && addresssender.data.length == 0 &&
                                                        <Typography component="span" variant="caption" sx={{ color: "#EF4444", fontWeight: 600 }}>
                                                            Please add sender address 
                                                            <Link to="/settings/address-sender" style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 700 }}> here </Link>
                                                        </Typography>
                                                    }
                                                    {errors.preferred_sender_id && addresssender && addresssender.data && addresssender.data.length !== 0 &&
                                                        <Typography component="span" variant="caption" sx={{ color: "#EF4444", fontWeight: 600 }}>
                                                            This field is required.
                                                        </Typography>
                                                    }
                                                </FormHelperText>
                                            </FormControl>
                                        </Box>
                                    </CardContent>
                                }
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <TextField 
                                            label="Name*"
                                            variant="outlined"
                                            size="small"
                                            name="sender_name"
                                            value={values.sender_name}
                                            onChange={handleInputChange}
                                            error={!!errors.sender_name}
                                            helperText={errors.sender_name}
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField 
                                            label="Company"
                                            variant="outlined"
                                            size="small"
                                            name="sender_company"
                                            value={values.sender_company !== "" ? values.sender_company : ""}
                                            onChange={handleInputChange}
                                            error={!!errors.sender_company}
                                            helperText={errors.sender_company}
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField 
                                            label="Phone Number"
                                            name="sender_phone"
                                            size="small"
                                            value={values.sender_phone}
                                            variant="outlined"
                                            onChange={handleInputChange}
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField 
                                            label="Email"
                                            variant="outlined"
                                            size="small"
                                            name="sender_email"
                                            value={values.sender_email}
                                            onChange={handleInputChange}
                                            error={!!errors.sender_email}
                                            helperText={errors.sender_email}
                                            sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }} 
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField 
                                            label="Address1*"
                                            variant="outlined"
                                            size="small"
                                            name="sender_address"
                                            value={values.sender_address}
                                            inputProps={{ maxLength: 35 }}
                                            onChange={handleInputChange}
                                            error={!!errors.sender_address}
                                            helperText={errors.sender_address}
                                            sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }} 
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField 
                                            label="Address2"
                                            variant="outlined"
                                            size="small"
                                            name="sender_address2"
                                            value={values.sender_address2}
                                            inputProps={{ maxLength: 35 }}
                                            onChange={handleInputChange}
                                            error={!!errors.sender_address2}
                                            helperText={errors.sender_address2}
                                            sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }} 
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField 
                                            label="City*"
                                            variant="outlined"
                                            size="small"
                                            name="sender_city"
                                            value={values.sender_city}
                                            onChange={handleInputChange}
                                            error={!!errors.sender_city}
                                            helperText={errors.sender_city}
                                            sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }} 
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField 
                                            label="Postal Code*"
                                            variant="outlined"
                                            size="small"
                                            name="sender_postal_code"
                                            inputProps={{ maxLength: 10 }}
                                            value={values.sender_postal_code}
                                            onChange={handleInputChange}
                                            error={!!errors.sender_postal_code}
                                            helperText={errors.sender_postal_code}
                                            sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }} 
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Autocomplete
                                            className="help-text-error"
                                            disablePortal
                                            size="small"
                                            name="sender_country_code"
                                            id="country-select-demo"
                                            options={filteredCountryData || []}
                                            autoHighlight
                                            loading={country_code && country_code.loading}
                                            getOptionLabel={(option) => option.name || ""}
                                            value={getSelectedCountry(values && values.sender_country_code)}
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': { 
                                                    borderRadius: '10px',
                                                    '& fieldset': { borderColor: '#E2E8F0' }
                                                }
                                            }}
                                            renderOption={(props, option) => (
                                                <MenuItem {...props} value={option.code} key={option.code} sx={{ fontSize: '13px' }}>
                                                    {option.icon} {option.name}
                                                </MenuItem>
                                            )}
                                            onChange={(event, value) => {
                                                if (value !== null) {
                                                    onChangeCountry(value.code);
                                                } else {
                                                    onChangeCountry("");
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="country*"
                                                    variant="outlined"
                                                    helperText={errors.sender_country_code}
                                                    error={!!errors.sender_country_code}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            className="help-text-error"
                                            disablePortal
                                            size="small"
                                            name="sender_province_code"
                                            id="state-select-demo"
                                            options={state && state.data || []}
                                            autoHighlight
                                            loading={(state && state.loading) || (country_code && country_code.loading)}
                                            getOptionLabel={(option) => option.name || ""}
                                            value={getSelectedState(values && values.sender_province_code)}
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': { 
                                                    borderRadius: '10px',
                                                    '& fieldset': { borderColor: '#E2E8F0' }
                                                }
                                            }}
                                            renderOption={(props, option) => (
                                                <MenuItem {...props} value={option.code} key={option.code} sx={{ fontSize: '13px' }}>
                                                    {option.name}
                                                </MenuItem>
                                            )}
                                            onChange={(event, value) => {
                                                if (value !== null) {
                                                onSelectStateChange(value.code);
                                                } else {
                                                onSelectStateChange("");
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="state*"
                                                    variant="outlined"
                                                    helperText={errors.sender_province_code}
                                                    error={!!errors.sender_province_code}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField 
                                            label="Reference no"
                                            variant="outlined"
                                            size="small"
                                            name="sender_reference_no"
                                            value={values.sender_reference_no}
                                            inputProps={{ maxLength: 35 }}
                                            onChange={handleInputChange}
                                            sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '10px', '& fieldset': { borderColor: '#E2E8F0' } } }} 
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        </CardContent>
                    </Collapse>
                </Box>
            </Card>
        </>
    )
};

export default SenderAddressSelect;